export const HELP_THEME = {
	primary: '#4361EE',
	primarySoft: '#EFF6FF',
	primaryBorder: '#BFDBFE',
	gradient: 'linear-gradient(135deg, #4361EE 0%, #4CC9F0 100%)',
	gradientHover: 'linear-gradient(135deg, #3651DE 0%, #3BB8E0 100%)',
	text: '#0F172A',
	muted: '#64748B',
	body: '#334155',
	border: '#E2E8F0',
	surface: '#F8FAFC',
	white: '#FFFFFF',
}

/** Internal section keys for navigation inside the Help Center. */
export const HELP_VIEWS = {
	HOME: 'home',
	VIDEOS: 'videos',
	// GUIDE: 'guide',
	FAQS: 'faqs',
	WHATS_NEW: 'whats-new',
	WELLBEING: 'wellbeing',
	// DOCS: 'docs',
	// SUPPORT: 'support',
}

export const HELP_RESOURCE_CARDS = [
	{
		id: 'demo-videos',
		view: HELP_VIEWS.VIDEOS,
		emoji: '🎥',
		title: 'Demo Videos',
		description: 'Watch guided walkthroughs for key MyPeegu features.',
		available: true,
	},
	// {
	// 	id: 'user-guide',
	// 	view: HELP_VIEWS.GUIDE,
	// 	emoji: '📖',
	// 	title: 'User Guide',
	// 	description: 'Step-by-step guides for everyday counselling workflows.',
	// 	available: true,
	// },
	{
		id: 'faqs',
		view: HELP_VIEWS.FAQS,
		emoji: '❓',
		title: 'FAQs',
		description: 'Quick answers to common questions from schools and teams.',
		available: true,
	},
	{
		id: 'whats-new',
		view: HELP_VIEWS.WHATS_NEW,
		emoji: '🆕',
		title: "What's New",
		description: 'Latest product updates, improvements, and release notes.',
		available: true,
	},
	{
		id: 'wellbeing',
		view: HELP_VIEWS.WELLBEING,
		emoji: '🌿',
		title: 'Wellbeing',
		description: 'Breathing exercise, stress relief, and counsellor self-care.',
		available: true,
	},
	{
		id: 'counsellor-toolkit',
		emoji: '🧰',
		title: 'Counsellor Toolkit',
		description: 'Practical PDF toolkit and resources for counsellors.',
		available: true,
		href: '/resource/share/0c69fc902b28',
	},
	{
		id: 'special-education-toolkit',
		emoji: '📘',
		title: 'Special Education Toolkit',
		description: 'Practical toolkit and resources for special educators.',
		available: true,
		href: '/resource/share/05eb9d552ec9',
	},
	// {
	// 	id: 'documentation',
	// 	view: HELP_VIEWS.DOCS,
	// 	emoji: '📄',
	// 	title: 'Documentation',
	// 	description: 'Detailed platform documentation for admins and educators.',
	// 	available: true,
	// },
	// {
	// 	id: 'contact-support',
	// 	view: HELP_VIEWS.SUPPORT,
	// 	emoji: '📞',
	// 	title: 'Contact Support',
	// 	description: 'Reach your institution admin or the MyPeegu support team.',
	// 	available: true,
	// },
]

export const HELP_FAQS = [
	{
		id: 'faq-1',
		question: 'What is MyPeegu?',
		answer:
			'MyPeegu is an AI-assisted platform that helps schools manage student wellbeing, counselling, assessments, documentation, and professional decision support.',
	},
	{
		id: 'faq-2',
		question: 'Does AI replace professional judgement?',
		answer:
			'No. AI-generated content is advisory only. Users must review, verify, and approve all AI outputs before relying on or sharing them.',
	},
	{
		id: 'faq-3',
		question: 'Who owns the data uploaded to MyPeegu?',
		answer:
			'All institutional and student data remains the property of the respective educational institution or lawful data owner. MyPeegu acts as the technology platform.',
	},
	{
		id: 'faq-4',
		question: 'How do I get started quickly?',
		answer:
			'Open Help Center → Demo Videos → Getting Started. Watch “Welcome to MyPeegu” and “Dashboard Overview” for a fast orientation.',
	},
	{
		id: 'faq-5',
		question: 'Where can I find Virtual Counselling help?',
		answer:
			'Go to Demo Videos and filter by the Virtual Counselling category, or search for “counselling” in the Help Center search bar.',
	},
]

export const HELP_GUIDE_ITEMS = [
	{
		id: 'guide-1',
		title: 'Sign in and explore the dashboard',
		body: 'Use the left navigation to move between Academic, Initiations, Counselling, and Reports.',
	},
	{
		id: 'guide-2',
		title: 'Add students and classrooms',
		body: 'Set up academic structure first so counselling and assessment workflows stay organised.',
	},
	{
		id: 'guide-3',
		title: 'Start a counselling session',
		body: 'Use Virtual Counselling tools for live sessions and review AI-assisted notes before saving.',
	},
	{
		id: 'guide-4',
		title: 'Review permissions carefully',
		body: 'Ensure each role only has the access needed for their responsibilities.',
	},
]

export const HELP_WHATS_NEW = [
	{
		id: 'rn-one-to-one',
		title: 'One-to-One Session guide',
		date: '2026',
		body: 'New guidance for running One-to-One counselling sessions. Tap to open the PDF resource.',
		href: '/resource/share/2ff7b2ab8870',
	},
	{
		id: 'rn-1',
		title: 'Help Center launched',
		date: '2026',
		body: 'A dedicated Help Center with demo videos, FAQs, and guided resources is now available from the header and floating widget.',
	},
	{
		id: 'rn-2',
		title: 'Virtual Counselling improvements',
		date: '2026',
		body: 'Enhanced session flows and clearer guidance for counsellors during live sessions.',
	},
]

export const HELP_DOCS = [
	{
		id: 'doc-1',
		title: 'Platform overview',
		body: 'High-level introduction to MyPeegu modules and recommended daily workflows.',
		type: 'article',
	},
	{
		id: 'doc-2',
		title: 'Privacy Policy & Terms of Use',
		body: 'Review privacy, confidentiality, AI limitations, and user responsibilities from the Welcome disclaimer Know More section.',
		type: 'policy',
	},
	{
		id: 'doc-3',
		title: 'Admin setup checklist',
		body: 'Recommended order for configuring schools, roles, classrooms, and student data.',
		type: 'checklist',
	},
]

export const HELP_SUPPORT = {
	title: 'We’re here to help',
	body: 'For account or access issues, contact your institution’s designated administrator first. For product support, reach the MyPeegu Support Team through your school’s MyPeegu contact channel.',
	tips: [
		'Include your school name and a short description of the issue.',
		'Attach screenshots when possible.',
		'Note the page or feature where you need help.',
	],
}
